module.exports = __webpack_public_path__ + "img/profile-pic-work.6b943a3b.jpg";